/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction, Slice } from '@reduxjs/toolkit';
import { metricsApi } from 'services/newApi/metricsApi';
import { MetricResponse } from 'services/types';

export interface MetricsState {
  selectedMetricId?: MetricResponse['metricId'];
  metricsList: MetricResponse[];
}

const initialState: MetricsState = {
  selectedMetricId: undefined,
  metricsList: [],
};

export const metricsSlice: Slice<MetricsState> = createSlice({
  name: 'metricsSlice',
  initialState,
  reducers: {
    updateSelectedMetricId: (state, action: PayloadAction<string>) => {
      state.selectedMetricId = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder.addMatcher(
      metricsApi.endpoints.getMetrics.matchFulfilled,
      (state, action: PayloadAction<MetricResponse[]>) => {
        if (action.payload.length > 0) {
          state.selectedMetricId = action.payload[0].metricId;
          state.metricsList = action.payload;
        }
      }
    );
  },
});

export const { updateSelectedMetricId } = metricsSlice.actions;
